import axios from 'axios';

export default {
  FETCH_ARTICLES ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('user/findAllToneArticles')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('articles', JSON.stringify(payload));
                    commit('SET_ARTICLES', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDARTICLE ({ commit }, articleId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`user/findAllToneArticles`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedArticle = payload.filter(x => {
              return x.toneArticleId.toString() === articleId.toString()
            });

            console.log('found article', selectedArticle)
            commit('SET_SELECTED_ARTICLE', selectedArticle[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_ARTICLE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add Article payload : ", payload);
            axios.post('user/addToneArticle', payload)
                .then((response) => {
                    console.log('ADD_ARTICLE action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_ARTICLE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_ARTICLE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/user/updateToneArticle', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_ARTICLE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/articles/actions.js